
import { createSlice } from "@reduxjs/toolkit";

const user = createSlice({
    name: "user",
    initialState : {
        loggedin : 'no',
        userDetails : {
            ID : '',
            UserName : '',
            UserRole : '',
            UserEmail : '',
            TeamLeadID: '',
            UserID: '',
        } 
    },
    
    reducers:{
        setUserDetails : (state, action) => {
            state.loggedin = action.payload.isLogin
            state.userDetails = action.payload.userdetails
        }
    }
});

export const {setUserDetails} = user.actions;
export default user.reducer;